"use strict";

var _assign = function __assign() {
  return (_assign = Object.assign || function (e) {
    for (var n, t = 1, r = arguments.length; t < r; t++) {
      for (var u in n = arguments[t]) {
        Object.prototype.hasOwnProperty.call(n, u) && (e[u] = n[u]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    __importDefault = function __importDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
},
    react_1 = (Object.defineProperty(exports, "__esModule", {
  value: !0
}), __importDefault(require("react")));

function Link(e) {
  var n = {
    xDown: null,
    xUp: null
  };
  return react_1.default.createElement("a", _assign({
    onClick: function onClick(e) {
      n.xDown !== n.xUp && e.preventDefault();
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault(), n.xUp = null, n.xDown = e.clientX;
    },
    onMouseUp: function onMouseUp(e) {
      e.preventDefault(), n.xUp = e.clientX;
    }
  }, e), e.children);
}

exports.default = Link;